import React from 'react'

import Footer from '../../../componenets/footer/Footer'
import Listedprojectscontainer from '../../../containers/thrustarea/listedprojects/Listedprojectscontainer'

function TAListedprojects() {
  return (
    <div className='listedprojects'>
        {/* <Header /> */}
        {/* <Navbar /> */}
        <Listedprojectscontainer />
        {/* <Footer /> */}
    </div>
  )
}

export default TAListedprojects